import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    semaforoResultado: [],
  },

  getters: {
    getSemaforoResultado: (state) => state.semaforoResultado,
  },

  mutations: {
    SET_SEMAFORO_RESULTADO(state, semaforoResultado) {
      state.semaforoResultado = semaforoResultado;
    },
  },

  actions: {
    async fetchSemaforoResultado({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catSemaforoResultado')
        .then((response) => {
          commit('SET_SEMAFORO_RESULTADO', response.data.data);
        });
    },
  },
};
